import { render, staticRenderFns } from "./Osa015.vue?vue&type=template&id=936b20f4&scoped=true"
var script = {}
import style0 from "./Osa015.vue?vue&type=style&index=0&id=936b20f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936b20f4",
  null
  
)

export default component.exports